import { Session } from './../models/session';
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import {environment} from '../../environments/environment';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  constructor(private http: HttpClient,
    private translocoService:TranslocoService) {
  }

  public startCheckingSessionExpiry: boolean = false;
  public readonly sessionExpiredSubject = new BehaviorSubject(false);
  public sessionId: string = '';

  get(sessionId: string): Observable<Session> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      withCredentials: true
    };
    const url: string = environment.PAYMENT_UI + `/epms/payment/session/${sessionId}`;
    this.setActiveLang();
    return this.http.get<Session>(url, httpOptions)
  }

  setActiveLang(){
    if(window.sessionStorage.getItem('curUserLan')!==null){
      this.translocoService.setActiveLang(window.sessionStorage.getItem('curUserLan'));
    }
  }
}
